import { SET_PRESET_LIST, SET_PRESET_LISTS, SET_FILTERED_LIST } from '../actions/ListAction';
// temp
import CountriesList from './json/countries.json';
import CurrencyList from './json/currencies.json';
import MalaysiaBankList from './json/malaysia_banks.json';
import MalaysiaStateList from './json/malaysia_state.json';
import MCC from './json/mcc.json';
import CUPMCC from './json/cup_mcc.json';
import MOTOMCC from './json/moto_mcc.json';

import PostCodeCity from '../../lists/Postcode_map_city.json';
import PostCodeState from '../../lists/Postcode_map_state.json';
import PostCodeCityText from '../../lists/Postcode_map_city_text.json';
import PostCodeStateText from '../../lists/Postcode_map_state_text.json';
import Postcode from '../../lists/Postcode.json';
import State from '../../lists/State.json';
import City from '../../lists/City.json';
import SSICCode from '../../lists/SSIC_code.json';
import MCCVisa from '../../lists/MCC_visa.json';
import CimbPreviousAcquirer from '../../lists/Cimb_previous_acquirer.json';
import CimbCardlinkPran from '../../lists/Cimb_cardlink_pran.json';
import MCCIndustry from '../../lists/MCC_industry.json';
import PSICCode from '../../lists/PSIC_code.json';
import CountryDialCode from '../../lists/Country_dial_code.json';
import MSIC from '../../lists/MSIC.json';
import KBLI from '../../lists/KBLI.json';
import PHPostCode from '../../lists/PH_postcode.json';
import PHState from '../../lists/PH_states.json';

// Bundle SG Postcode and Street, and Building mapping only if it's NETS client
const PostcodeSG = 'fetch';
const PostcodeSGStreetBuilding = 'fetch';

const INITIAL_STATE = {
    lists: {
        1: CountriesList,
        2: MalaysiaBankList,
        3: MalaysiaStateList,
        4: MCC,
        5: CUPMCC,
        6: MOTOMCC,
        7: PostCodeCity,
        8: PostCodeState,
        9: Postcode,
        10: State,
        11: City,
        12: PostCodeCityText,
        13: PostCodeStateText,
        14: SSICCode,
        16: MCCVisa,
        17: PostcodeSG,
        18: PostcodeSGStreetBuilding,
        19: CimbPreviousAcquirer,
        20: CimbCardlinkPran,
        21: MCCIndustry,
        22: CurrencyList,
        23: PSICCode,
        24: CountryDialCode,
        25: MSIC,
        26: KBLI,
        27: PHPostCode,
        28: PHState,
    },
    fetching: false,
    error: null,
};

const MCC_MISC_MAPPING = {
    1799: ['43909'],
    4215: ['53200'],
    4784: ['52214'],
    4812: ['61101'],
    5045: ['47411'],
    5072: ['46639'],
    5200: ['47199'],
    5251: ['47520'],
    5399: ['47199'],
    5411: ['47112', '47113'],
    5462: ['47216'],
    5499: ['47199'],
    5532: ['45300'],
    5533: ['45300'],
    5541: ['47300'],
    5571: ['45401', '45402'],
    5611: ['47711'],
    5621: ['47711'],
    5631: ['47711'],
    5641: ['47711'],
    5651: ['47711'],
    5661: ['47712'],
    5691: ['47711'],
    5712: ['47591'],
    5713: ['47533'],
    5722: ['47595'],
    5732: ['47739'],
    5812: ['56101'],
    5813: ['56101'],
    5814: ['56103'],
    5912: ['47721'],
    5940: ['47635'],
    5941: ['47631'],
    5943: ['47612'],
    5944: ['47732'],
    5945: ['47640'],
    5947: ['47735'],
    5949: ['47739'],
    5977: ['47722'],
    5993: ['47230'],
    5995: ['47738'],
    5999: ['47739'],
    6300: ['65121'],
    7011: ['55101', '55103', '55108'],
    7230: ['96020'],
    7297: ['96091'],
    7298: ['96020'],
    7299: ['96099'],
    7399: ['82990'],
    7523: ['52213'],
    7538: ['45201'],
    7542: ['45203'],
    7997: ['94990'],
    8011: ['86101'],
    8021: ['86203'],
    8043: ['47737'],
    8099: ['86201'],
    8299: ['85499'],
    8999: ['96099'],
};

function filterList(id, filterKey) {
    const mappingConfig = {
        malaysia_standard_industrial_classification: {
            mapping: MCC_MISC_MAPPING,
            stateListId: 25,
        },
    };

    const config = mappingConfig[id];
    if (!config) return { stateListId: null, list: [] };

    const { mapping, stateListId } = config;
    const keys = mapping?.[filterKey] || [];
    const list =
        keys && keys.length
            ? INITIAL_STATE.lists[stateListId].filter(item => keys.includes(item.value))
            : INITIAL_STATE.lists[stateListId];
    return { stateListId, list };
}

export default function ListReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case SET_PRESET_LIST: {
            const { id, list } = action.payload;
            return {
                ...state,
                lists: {
                    ...state.lists,
                    [id]: list,
                },
            };
        }
        case SET_PRESET_LISTS: {
            const { lists } = action;
            return {
                ...state,
                lists: {
                    ...state.lists,
                    ...lists,
                },
            };
        }
        case SET_FILTERED_LIST: {
            const { id, filterKey } = action.payload;
            const { stateListId, list } = filterList(id, filterKey);
            return {
                ...state,
                lists: {
                    ...state.lists,
                    [stateListId]: list,
                },
            };
        }
        default:
            return state;
    }
}
